import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import '../styles/congratulations.css';
import { useMetadata } from '../hooks/useMetadata';
import SignatureRetryNotice from '../components/application/SignatureRetryNotice';
import { clearApplicationSignatureMark } from '../utils/applicationSignatureMark';
import { REACT_APP_COUNTRY } from '../config';
import { signatureHoldVariant } from '../utils/signatureAttempt';

const SignatureRejectedPage: React.FC = () => {
  useMetadata();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const quoteId = searchParams.get('quoteID') || searchParams.get('quoteId') || '';
  const signatureError = searchParams.get('error');
  // INT has no /logalty route (it is commented out). Offering "Reintentar firma"
  // there used to navigate to a dead page.
  const canRetrySignature = REACT_APP_COUNTRY === 'MX' || REACT_APP_COUNTRY === 'BR';
  const logoSrc = REACT_APP_COUNTRY === 'INT' ? '/logo-ole.svg' : '/logo-ole-mx.png';

  // OUW-276: la firma no se completó; el portal no puede decir «Recibimos tu firma».
  useEffect(() => {
    clearApplicationSignatureMark();
  }, []);

  const retryPath = () => {
    const id = encodeURIComponent(quoteId);
    if (REACT_APP_COUNTRY === 'BR') {
      return `/signature?quoteID=${id}&retry=1`;
    }
    return `/logalty?quoteID=${id}&retry=1`;
  };

  if (quoteId && canRetrySignature) {
    return (
      <div className="congratulations-container">
        <div className="congratulations-header">
          <img
            src={logoSrc}
            alt="Olé Logo"
            className="congratulations-logo"
          />
        </div>
        <SignatureRetryNotice
          quoteId={quoteId}
          variant={signatureHoldVariant({ signatureError })}
          onRetry={() => navigate(retryPath())}
        />
      </div>
    );
  }

  return (
    <div className="congratulations-container">
      <div className="congratulations-header">
        <img 
          src={logoSrc}
          alt="Olé Logo" 
          className="congratulations-logo"
        />
      </div>
      <div className='rejected-icon'>
        <img 
          src="/icon-sign-rejected.png" 
          alt="Olé Logo" 
          className="congratulations-logo"
        />
      </div>
      <div className="rejected-content">
        <div className="rejected-message">
          <h1 data-testid="rechazo-titulo-solicitud" className="rejected-title">
            Has rechazado la firma de tu solicitud
          </h1>
          <p data-testid="rechazo-texto-cancelada" className="rejected-description">
            Lamentamos comunicarte que al haber rechazo la firma electrónica, tu <br/> <b>solicitud ha sido cancelada</b> por ti.
          </p>
          <p data-testid="rechazo-texto-contacto" className="rejected-description">
            Comunícate con tu agente para iniciar una nueva solicitud.
          </p>
          {quoteId && REACT_APP_COUNTRY === 'INT' && (
            <p className="rejected-description">
              <a data-testid="rechazo-link-cotizacion" href={`/quote?quoteID=${encodeURIComponent(quoteId)}`}>
                Volver a mi cotización
              </a>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default SignatureRejectedPage;
